import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatNumber(n, locale = 'zh-TW') {
  return new Intl.NumberFormat(locale === 'zh-TW' ? 'zh-TW' : 'en-US').format(n);
}

export function getStatusColor(status) {
  switch (status) {
    case 'normal':
      return 'bg-green-100 text-green-800';
    case 'overtime':
      return 'bg-blue-100 text-blue-800';
    case 'holiday':
      return 'bg-orange-100 text-orange-800';
    case 'holiday_overtime':
      return 'bg-red-100 text-red-800';
    case 'no_work':
      return 'bg-gray-200 text-gray-600';
    default:
      return 'bg-gray-100 text-gray-800';
  }
}

export function getRoleColor(role) {
  switch (role) {
    case 'admin':
      return 'bg-purple-100 text-purple-800';
    case 'section_supervisor':
      return 'bg-blue-100 text-blue-800';
    case 'section_user':
      return 'bg-gray-100 text-gray-800';
    case 'contractor':
      return 'bg-amber-100 text-amber-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
}

export function truncate(str, length = 50) {
  if (!str) return '';
  if (str.length <= length) return str;
  return str.substring(0, length) + '...';
}

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}

export default {
  cn,
  formatNumber,
  getStatusColor,
  getRoleColor,
  truncate,
  downloadBlob,
};
